module.exports = __webpack_public_path__ + "static/media/landing-mobile-shirt.996a7a23.png";